import React from 'react'
import { Typography } from 'antd'
import { OrgDashboardSectionKey, sectionHeadingElementId } from './section-well'
import './org-dashboard.scss'

type Props = {
    sectionKey: OrgDashboardSectionKey
    title: string
    /** Controls that narrow or reorder the table, at the right-hand end of the header. */
    filters?: React.ReactNode
    /** Buttons at the right-hand end of the header. */
    actions?: React.ReactNode
}

/**
 * DataView's header markup and class names. DataViewHeader itself reads DataView's context, which does not exist
 * here, so the same structure is written out and the platform's DataView stylesheet styles it: the header bar, the
 * bold title and the width of a search box. The title and the controls are siblings in the one bar, so the stylesheet
 * can put the title at the left edge and the controls at the right edge, all centred on the bar's height.
 *
 * The title is the section's heading: it is what the section is labelled by and where focus returns when a retry
 * removes the control that had it. It is an h5 for DataView's look and announced as level 3, the level the
 * section headings sit at in the page's outline.
 */
export const DashboardTableHeader: React.FC<Props> = ({ sectionKey, title, filters, actions }) => (
    <div className="data-view-header org-dashboard-table-header">
        <div className="data-view-title">
            <Typography.Title
                level={5}
                aria-level={3}
                id={sectionHeadingElementId(sectionKey)}
                tabIndex={-1}
                className="org-dashboard-table-title"
            >
                {title}
            </Typography.Title>
        </div>
        {filters ? <div className="data-view-filters org-dashboard-table-header-controls">{filters}</div> : null}
        {actions ? (
            <div className="data-view-header-right">
                <div className="data-view-table-actions">{actions}</div>
            </div>
        ) : null}
    </div>
)
